module.exports = __webpack_public_path__ + "img/icon-file.0b2f76a5.svg";